// Renders an icon held inside a data array. A `.map()` expression body cannot
// do the `const Icon = ...` trick the sidebar uses, so the array keeps the
// lucide component and this mounts it — same icons, same sizing, no emoji.
const DynIcon = ({ icon: Comp, size = 16 }) => (Comp ? <Comp size={size} /> : null);

export default DynIcon;
